<template lang="pug">
#base-header
    .view-container
        .base-container
            .base-title-container
                h1.base__title
                    i.voltar.mdi.mdi-arrow-left(
                        v-if='voltarPara',
                        @click='irParaRota(voltarPara)'
                    )
                    | {{ titulo }}
                .base__breadcrumb(v-if='breadcrumb')
                    el-breadcrumb(separator='.')
                        el-breadcrumb-item(
                            v-for='(sub, index) in breadcrumb',
                            :key='index'
                        )
                            span.link-breadcrumb(@click='irParaRota(sub.rota)')
                                | {{ sub.nome }}
            el-tooltip(v-if='tooltip', placement='bottom')
                div(
                    slot='content',
                    style='max-width: 200px; text-align: justify'
                ) {{ tooltip }}
                .base-button-container
                    slot(name='direita')
                    el-button.base-button-container__btn(
                        type='primary',
                        :icon='icon',
                        v-if='exibeBotao',
                        :disabled='desabilitaBotao',
                        @click='emit(tipoBotao.PRINCIPAL, null)'
                    )
                        | {{ btnTexto }}
                    el-button.base-button-container__btn(
                        v-for='(botaoSecundario, botaoSecundarioIndex) in botoesSecundarios',
                        :key='botaoSecundarioIndex',
                        :icon='botaoSecundario.icone',
                        @click='emit(tipoBotao.SECUNDARIO, botaoSecundario)'
                    )
                        | {{ botaoSecundario.nome }}
                    component(
                        :is='componenteAuxiliarBotaoHeader',
                        :showComponent='showComponenteAuxiliar',
                        :idCertificacao='idCertificacao'
                    )
            .base-button-container(v-else)
                slot(name='direita')
                el-button.base-button-container__btn(
                    :id='id',
                    type='primary',
                    :icon='icon',
                    v-if='exibeBotao',
                    :disabled='desabilitaBotao',
                    @click='emit(tipoBotao.PRINCIPAL, null)'
                )
                    | {{ btnTexto }}
                el-button.base-button-container__btn-secondary(
                    v-for='(botaoSecundario, botaoSecundarioIndex2) in botoesSecundarios',
                    :key='botaoSecundarioIndex2',
                    type='primary',
                    :icon='botaoSecundario.icone',
                    @click='emit(tipoBotao.SECUNDARIO, botaoSecundario)'
                )
                    | {{ botaoSecundario.nome }}
                component(
                    :is='componenteAuxiliarBotaoHeader',
                    :showComponent='showComponenteAuxiliar',
                    :idCertificacao='idCertificacao'
                )
</template>

<script>
// IMPORTANTE !! Utilize a classe .view-container-base-header para complementar o uso desse componente.
import DropdownOptionsExportarRelatorio from './certificacao/DropdownOptionsExportarRelatorio.vue';

export default {
    name: 'BaseHeader',
    emits: ['btnHeaderClicado'],
    components: {
        DropdownOptionsExportarRelatorio
    },
    data() {
        return {
            idCertificacao: this.$route?.params?.idCertificacao,
            tipoBotao: {
                PRINCIPAL: 'PRINCIPAL',
                SECUNDARIO: 'SECUNDARIO'
            }
        };
    },
    props: {
        titulo: {
            type: String,
            default: () => ''
        },
        voltarPara: {
            type: [Object, Boolean, String],
            default: () => null
        },
        breadcrumb: {
            type: Array,
            default: () => []
        },
        btnTexto: {
            type: String,
            default: () => ''
        },
        icon: {
            type: String,
            default: () => ''
        },
        exibeBotao: {
            type: Boolean,
            default: false
        },
        desabilitaBotao: {
            type: Boolean,
            default: false
        },
        tooltip: {
            type: String,
            default: () => null
        },
        id: {
            type: String,
            default: () => ''
        },
        componenteAuxiliarBotaoHeader: {
            type: String,
            default: () => null,
            required: false
        },
        showComponenteAuxiliar: {
            type: Boolean,
            default: () => false,
            required: false
        },
        botoesSecundarios: {
            type: Array,
            required: false
        }
    },
    methods: {
        irParaRota(rota) {
            if (!rota) return;
            if (typeof rota === 'boolean' && rota) {
                this.$router.go(-1);
            } else if (typeof rota === 'string' && rota === 'emit') {
                this.$emit('voltarClicado');
            } else if (this.$route.name !== rota.route) {
                this.$router.push({ name: rota.route });
            }
        },
        emit(tipoBotao, botao) {
            if (tipoBotao === this.tipoBotao.PRINCIPAL) {
                this.$emit('btnHeaderClicado');
            } else {
                this.$emit('botaoSecundarioHeaderClicado', botao);
            }
        }
    }
};
</script>

<style lang="scss">
#base-header {
    background: var(--white);
    box-shadow: 0 1px 3px 0 var(--block-shadow);
    .base-container {
        width: 100%;
        min-height: 87px;
        background: var(--white);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .base__title {
            display: flex;
            align-items: center;
            .voltar {
                cursor: pointer;
                font-size: 27px;
                color: #303133;
                margin-right: 5px;
            }
            .voltar:hover {
                color: var(--secondary);
            }
        }
        .base-title-container {
            display: flex;
            flex-direction: column;
            .base__title {
                font-weight: 600;
            }
            .base__breadcrumb {
                margin-top: 8px;
                span.link-breadcrumb {
                    color: #1989fa;
                    text-decoration: underline;
                    cursor: pointer;
                }
                span.link-breadcrumb:hover {
                    color: var(--secondary);
                }
            }
        }
    }
    .button-outline {
        border-color: var(--secondary-two) !important;
        color: var(--white) !important;
        background: var(--secondary-two) !important;
    }
    .base-button-container {
        position: relative;
    }
    .base-button-container__btn {
        span {
            margin-left: 5px;
        }
        i {
            color: #ffffff;
        }
    }
    .base-button-container__btn-secondary {
        background-color: #f4f4f5;
        border-color: #f4f4f5;
        span {
            margin-left: 5px;
            color: #183b57 !important;
        }
        i {
            color: #183b57 !important;
        }
    }
}
</style>
